/**
 * Cookiebeleid — JURIDISCH GEVALIDEERDE TEKST. Niet herformuleren.
 *
 * Traduction du français, phrase par phrase : transport, pas rédaction.
 * {{DUREE_SESSION}} porte la durée RÉELLE du cookie de session, lue dans
 * le code d'authentification (voir content/legal/index.js) — le jeton est
 * conservé à l'identique, jamais recopié en dur.
 *
 * La référence à l'art. 129 de la loi du 13 juin 2005 garde sa forme
 * officielle néerlandaise (« wet van 13 juni 2005 betreffende de
 * elektronische communicatie »).
 */
const COOKIES_NL = String.raw`
# Cookiebeleid

**Archer · archer.law**
Laatst bijgewerkt: {{DATE_MISE_EN_LIGNE}}

*Dit document is beschikbaar in het Frans, het Nederlands en het Engels. In geval van tegenstrijdigheid tussen de taalversies heeft de Franse versie voorrang.*

## 1. Wat is een cookie?

Een cookie is een klein bestand dat bij het bezoek aan een site op uw toestel wordt geplaatst. Sommige zijn onmisbaar voor de werking van de site; andere dienen om het publieksbereik te meten of voor reclame en mogen enkel met uw **voorafgaande toestemming** worden geplaatst (art. 129 van de Belgische wet van 13 juni 2005 betreffende de elektronische communicatie en AVG).

## 2. De cookies die wij gebruiken

### 2.1. Strikt noodzakelijke cookies: geen toestemming vereist

Zij laten de site werken en kunnen niet worden uitgeschakeld:

| Cookie | Doel | Duur |
|---|---|---|
| Sessie / authenticatie | U aangemeld houden bij uw account | Sessie of {{DUREE_SESSION}} |
| Beveiliging (anti-CSRF) | Formulieren beschermen tegen vervalsing | Sessie |
| Voorkeuren | Uw taal en interfacekeuzes onthouden | 12 maanden |
| Toestemming | Uw cookiekeuzes onthouden | 6 maanden |

### 2.2. Reclame- en meetcookies: onderworpen aan uw toestemming

Wij gebruiken (of zijn van plan te gebruiken) trackers van reclameplatformen om de doeltreffendheid van onze campagnes te meten en relevante reclame te tonen:

| Tracker | Aanbieder | Doel |
|---|---|---|
| TikTok Pixel | TikTok Technology Limited | Campagnemeting, gerichte reclame |
| Meta Pixel | Meta Platforms Ireland Ltd | Campagnemeting, gerichte reclame |

**Deze trackers worden nooit geactiveerd vóór uw toestemming.** Zolang u niet op « Aanvaarden » hebt geklikt, wordt geen enkel reclamescript geladen en worden geen gegevens naar die platformen verzonden. De gegevens die na toestemming eventueel worden verzameld (bekeken pagina's, conversiegebeurtenissen, technische identificatoren) worden door die platformen verwerkt volgens hun eigen beleid, ook buiten de Europese Unie.

## 3. Uw keuzes

Bij uw eerste bezoek stelt een banner u voor om de niet-noodzakelijke cookies te **Aanvaarden** of te **Weigeren**, met dezelfde eenvoud voor beide keuzes. Weigeren beperkt uw toegang tot de Dienst niet.

U kunt uw keuze op elk moment wijzigen via de link « **Mijn cookies beheren** » onderaan de pagina. Uw keuze wordt 6 maanden bewaard, waarna zij u opnieuw wordt gevraagd.

U kunt uw browser ook zo instellen dat cookies worden geblokkeerd of verwijderd; het blokkeren van de strikt noodzakelijke cookies kan echter verhinderen dat u zich bij uw account aanmeldt.

## 4. Contact

Voor elke vraag over cookies en trackers: bonjour@archer.law.
`;

export default COOKIES_NL;
